import { DraftDocxViewer } from '@/components/drafts/DraftDocxViewer';
import Loading from '@/components/shared/Loading';
import { DRAFT_DOCX_EDITOR_EMPTY_CLASSNAME } from '@/drafting/constants';
import type { DraftDocumentVersionContent } from '@/hooks/useDraftDocuments';
import { apiErrorMessage } from '@/lib/api-client';

export function DraftVersionDiff({
  afterVersion,
  beforeVersion,
  buffer,
  error,
  isLoading,
  documentGuid,
}: {
  afterVersion: DraftDocumentVersionContent | null;
  beforeVersion: DraftDocumentVersionContent | null;
  buffer: ArrayBuffer | null;
  error: unknown;
  isLoading: boolean;
  documentGuid: string;
}) {
  if (isLoading) {
    return (
      <div className={DRAFT_DOCX_EDITOR_EMPTY_CLASSNAME}>
        <Loading />
      </div>
    );
  }

  if (error) {
    return (
      <div className={DRAFT_DOCX_EDITOR_EMPTY_CLASSNAME}>
        {apiErrorMessage(error) || 'Failed to load version changes'}
      </div>
    );
  }

  if (!beforeVersion || !afterVersion) {
    return (
      <div className={DRAFT_DOCX_EDITOR_EMPTY_CLASSNAME}>
        No previous version to compare.
      </div>
    );
  }

  return (
    <DraftDocxViewer
      buffer={buffer}
      documentId={`${documentGuid}-changes`}
      editorInstanceKey={0}
      error={error}
      isComparison
      isEditing={false}
      isLoading={false}
      onChange={() => undefined}
      title={`Changes - ${afterVersion.title}`}
      versionKey={afterVersion.version_number}
    />
  );
}
